import { AbstractControl, UntypedFormArray, UntypedFormGroup } from "@angular/forms";

export class FormHelper {
  public static setFieldDisabledStatus(control: AbstractControl, isEnabled: boolean) {
    if (!control) {
      return;
    }
    if (isEnabled) {
      control.enable();
    } else {
      control.disable();
    }
  }

  public static updateTreeValidity(group: UntypedFormGroup | UntypedFormArray | null, showImmediate = false): void {
    if (!group) {
      return;
    }
    const controls: AbstractControl[] =
      group instanceof UntypedFormArray ? group.controls : Object.values(group.controls);
    controls.forEach((abstractControl) => {
      if (abstractControl instanceof UntypedFormGroup || abstractControl instanceof UntypedFormArray) {
        this.updateTreeValidity(abstractControl, showImmediate);
      } else {
        if (showImmediate || !!abstractControl.value) {
          abstractControl.markAsTouched();
          abstractControl.markAsDirty();
        }
        abstractControl.updateValueAndValidity();
      }
    });
  }
}
